// src/app/core/auth/auth-interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  
  // URLs die kein Token benötigen
  const publicUrls = [
    '/api/auth/login',
    '/api/auth/register',
    '/api/auth/forgot-password',
    '/api/auth/reset-password',
  ];
  
  // Prüfe, ob die aktuelle URL in publicUrls enthalten ist
  const isPublicUrl = publicUrls.some(url => req.url.includes(url));
  
  // Spezialfall: Image-Abrufe (GET) sind öffentlich, aber Upload (POST) nicht
  const isPublicImageGet = req.method === 'GET' && req.url.includes('/api/images/');
  
  if (isPublicUrl || isPublicImageGet) {
    // Für öffentliche Anfragen kein Token hinzufügen
    return next(req);
  }
  
  const token = authService.getToken();
  if (token) {
    // Für authentifizierte Anfragen Token hinzufügen
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`)
    });
    return next(authReq);
  }
  
  // Falls kein Token vorhanden ist aber die Route geschützt
  return next(req);
};